import { useEffect, useRef, useState } from "react";
import "./Home.css";
import logo1 from "./assets/logo1.png";
import logo2 from "./assets/logo2.png";
import logo3 from "./assets/lo33.png";
import logo4 from "./assets/logo4.png";
import logo5 from "./assets/logo5.png";
import logo6 from "./assets/logo6.png";
import logo7 from "./assets/logo7.png";
import logo8 from "./assets/logo8.png";
import logo9 from "./assets/logo9.png";


const LOGOS = [
  { id: "logo-1", src: logo1 },
  { id: "logo-2", src: logo2 },
  { id: "logo-3", src: logo3 },
  { id: "logo-4", src: logo4 },
  { id: "logo-5", src: logo5 },
  { id: "logo-6", src: logo6 },
  { id: "logo-7", src: logo7 },
  { id: "logo-8", src: logo8 },
  { id: "logo-9", src: logo9 },
];

const HomeLogos = () => {
  const trackRef = useRef(null);
  const [centerIndex, setCenterIndex] = useState(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const items = Array.from(track.children);
    let frameId;

    const detectCenterLogo = () => {
      const centerX = window.innerWidth / 2;
      let closestIndex = -1;
      let minDistance = Infinity;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.left + rect.width / 2;
        const distance = Math.abs(centerX - itemCenter);

        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      setCenterIndex(closestIndex);
      frameId = requestAnimationFrame(detectCenterLogo);
    };

    frameId = requestAnimationFrame(detectCenterLogo);
    return () => cancelAnimationFrame(frameId);
  }, []);

  return (
    <section className="relative w-full overflow-hidden bg-[#F9FAFB] py-4 font-epilogue">
      <div
        className="absolute bg-img inset-0 z-0"
      />

      <div className="absolute top-0 left-0 h-full w-32 z-20 pointer-events-none bg-gradient-to-r from-[#F9FAFB] to-transparent" />
      <div className="absolute top-0 right-0 h-full w-32 z-20 pointer-events-none bg-gradient-to-l from-[#F9FAFB] to-transparent" />

      <div className="relative z-10 w-full overflow-hidden">
        <div className="scroll-container mx-auto">
          <div ref={trackRef} className="scroll-track flex gap-10 px-6">
            {[...LOGOS, ...LOGOS].map((logo, i) => (
              <div
                key={`${logo.id}-${i < LOGOS.length ? "a" : "b"}`}
                className={`logo-item transition-transform duration-500 ease-in-out ${
                  i === centerIndex
                    ? "scale-[1.2] opacity-100"
                    : "scale-100 opacity-70"
                }`}
              >
                <img
                  src={logo.src}
                  alt={logo.id}
                  className="h-20 w-auto transition-all duration-500 ease-in-out"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeLogos;
